import { Box, Button, Typography, styled, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useState, useEffect, useRef, useCallback } from "react";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { backendLinkLottery } from "../config";
import { Navigate, useNavigate } from "react-router-dom";
import classNames from "classnames";
import xss from "xss";
import Header from "../components/ReclamationHeader";
import styles from "../styles/components/concours.module.scss";
import "../css/datePicker.scss";
import { WilayaDropDown } from "../components/DropDown";
import { ImageUploaderLimited } from "../components/ImageUploader";
import { FailureToast } from "../components/SuccessToast";
import ThanksPopup from "../components/ThanksPopUp";
import ConcoursSentPopup from "../components/ConcoursSentPopup";
import bg_desktop from "../assets/tenants/hb/bg_desktop.gif";
import bg_mobile from "../assets/tenants/hb/bg_mobile.gif";
import concours_bg from  "../assets/tenants/hb/concours_bg.png"


export default function FormulaireConcours({
  // isStandaloneMode, 
  currentLang, setCurrentLang, 
  // isPWAInstallable, 
  // onInstallClick
}){

  const { t, i18n } = useTranslation(); 
  const navigate = useNavigate();
  const lotteryFormFields= useSelector((state)=> state.tenant.tenant.lotteryFormFields);
  const obligatoryLotteryFormFields= useSelector ((state)=> state.tenant.tenant.obligatoryLotteryFormFields);
  const tenantName= useSelector ((state)=> state.tenant.tenant.name);
  const enabledModules= useSelector((state)=> state.tenant?.tenant.enabledModules) || {};
  console.log("tenant name", tenantName);

  const [isSticky, setIsSticky]= useState(false);
  const [missingFieldsSentence, setMissingFieldsSentence] = useState(t("fillAllFieldsMessage"));
  const [showToastFields,setShowToastFields] = useState(false);
  const [emailError, setEmailError]= useState(false);
  const [isThanksPopUpVisible, setThanksPopUpVisible] = useState(false);
  const obligatoryConcoursFields = []

  const infoContainerRef= useRef(null);
  const imgContainerRef = useRef(null);
  
  const markToInfoContainer = ()=>{
    if (infoContainerRef.current){
      infoContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
      setTimeout(() => {
        infoContainerRef.current.classList.add("shake");
        setTimeout(() => {
          infoContainerRef.current.classList.remove("shake");
        }, 1000); 
      }, 500); 
    }
  };
  const markToImgContainer= ()=>{
    if (imgContainerRef.current){
      imgContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
      setTimeout(() => {
        imgContainerRef.current.classList.add("shake");
        setTimeout(() => {
          imgContainerRef.current.classList.remove("shake");
        }, 1000); 
      }, 500); 
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }; 
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const SCROLL_THRESHOLD = 5;

  const handleScroll = (e) => {
      const scrollPosition = window.scrollY;

      if (
      scrollPosition > SCROLL_THRESHOLD ||
      e.target.scrollTop > SCROLL_THRESHOLD
      ) {
      setIsSticky(true);
      } else {
      setIsSticky(false);
      }
  };
  const formatPhoneNumber = (value) => {
    // Keep only digits
    let digits = value.replace(/\D/g, "");

    // If user hasn't typed anything yet, just return empty
    if (!digits) return "";

    // Always make sure it starts with 0
    if (!digits.startsWith("0")) {
      digits = "0" + digits;
    }

    // Limit to 10 digits total
    digits = digits.slice(0, 10);

    // Format visually (space every two digits)
    const formatted = digits.match(/.{1,2}/g)?.join(" ") || "";

    return formatted.trim();
  };

  const goBack = useCallback(() => {
    navigate("/");
  }, [navigate]);
  
  const savedData= JSON.parse(localStorage.getItem("formData")) || {}

  const methods = useForm({
    defaultValues : {
      name: savedData.name || "",
      phone: savedData.phone ||"",
      email: savedData.email ||"",
      willaya: savedData.willaya ||"",
      compressedFiles: savedData.img_l||[]
    }
    });
    const { register, handleSubmit, control, setValue, getValues, formState } = methods
    const { errors } = formState;

  const verifyInputs = (data) => {
    // Helper function to check if a value is empty
    const isEmpty = (value) => {
      if (value instanceof Date) {
        return isNaN(value.getTime());
      }
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      if (typeof value === "object" && value !== null) {
        return Object.keys(value).length === 0;
      }
      return value === undefined || value === null || value === "";
    };

    // Special validation rules for specific fields
    const specialValidations = {
      name: (value, data) => {
        return !isEmpty(data.name);
      },
      phone: (value) => {
        if (!value) return false;
        const cleanPhone = value.replace(/\s/g, "");
        if (cleanPhone.length < 9 || cleanPhone.length > 10) {
          return false;
        }
        return true;
      },
      email: (value, data) => {
        return !isEmpty(data.email);
      },
      willaya: (value, data) => {
        return !isEmpty(data.willaya);
      },
      img_l: (value, data) =>
        Array.isArray(data.compressedFiles) && data.compressedFiles.length > 0,
    };

    // Verify each obligatory field
    for (const field of obligatoryLotteryFormFields) {
      // If field has special validation
      if (specialValidations[field]) {
        if (!specialValidations[field](data[field], data)) {
          setMissingFieldsSentence(t(field));
          return false;
        }
      }
      // Default validation
      else if (isEmpty(data[field])) {
        setMissingFieldsSentence(t(field)); // set sentence on toast according to missing fields translated
        return false;
      }
    }

    return true;
};
  const markMissingFields = (data) => {
    const isEmpty = (value) => {
      if (value instanceof Date) {
        return isNaN(value.getTime());
      }
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      if (typeof value === "object" && value !== null) {
        return Object.keys(value).length === 0;
      }
      return value === undefined || value === null || value === "";
    };

    // Special validation rules (same as in verifyInputs)
    const specialValidations = {
      name: (value, data) => {
        return !isEmpty(data.name);
      },
      phone: (value) => {
        if (!value) return false;
        const cleanPhone = value.replace(/\s/g, "");
        if (cleanPhone.length < 9 || cleanPhone.length > 10) {
          return false;
        }
        return true;
      },
      email: (value, data) => {
        return !isEmpty(data.email);
      },
      willaya: (value, data) => {
        return !isEmpty(data.willaya);
      },
      img_l: (value, data) =>
        Array.isArray(data.compressedFiles) && data.compressedFiles.length > 0,
    };

    // Mapping of fields to their corresponding scroll functions
    const scrollFunctions = {
      name: markToInfoContainer,
      phone: markToInfoContainer,
      email: markToInfoContainer,
      willaya: markToInfoContainer,
      img_l: markToImgContainer,
    };

    // Check each obligatory field and scroll to the first failing validation
    for (const field of obligatoryLotteryFormFields) {
      if (specialValidations[field]) {
        if (!specialValidations[field](data[field], data)) {
          if (scrollFunctions[field]) {
            scrollFunctions[field]();
          }
          return;
        }
      } else if (isEmpty(data[field])) {
        if (scrollFunctions[field]) {
          scrollFunctions[field]();
        }
        return;
      }
    }
  };
  const onSubmit = async (data, event) => {
    event.preventDefault();
    // console.log(utmSource);
    // console.log("isStandaloneMode", isStandaloneMode);
    // Preserve the current form state
    const currentFormState = getValues();
    if (!verifyInputs(data)) {
      setShowToastFields(true);
      markMissingFields(data);
      // Restore the form state if validation fails
      Object.keys(currentFormState).forEach((key) => {
        setValue(key, currentFormState[key]);
      });

      return;
    }
    if (data.email !== "" && !isValidEmail(data.email)) {
      setEmailError(true); // Show the error message
      return;
    } else {
      setEmailError(false); // Reset the error message if the email is valid
    }
    setThanksPopUpVisible(true);
    try {
        const formData = new FormData();
        data.name && formData.append("name", data.name);
        data.phone && formData.append("phone", data.phone.replace(/\s/g, "")); // Remove spaces for backend
        data.willaya && formData.append("willaya", data.willaya);
        // data.email && formData.append("email", data.email);
  
        // Helper function to convert base64 to Blob
        const base64ToBlob = (base64, mimeType) => {
          try {
            const base64Data = base64.includes(",")
              ? base64.split(",")[1]
              : base64;
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: mimeType });
          } catch (error) {
            console.error("Failed to convert base64 to Blob:", error);
            return null;
          }
        };
        /** Retrieve compressed images and store them in formData */
        if (data.compressedFiles.length > 0) {
          data.compressedFiles.forEach((fileData) => {
            const blob = base64ToBlob(fileData.base64, fileData.type);
            const file = new File([blob], fileData.name, {
              type: fileData.type,
              lastModified: fileData.lastModified,
            });
            formData.append("img_l", file);
          });
        }
        // Log FormData for debugging
        console.log("FormData contents:", formData);
        for (let [key, value] of formData.entries()) {
          if (value instanceof File) {
            console.log(
              `${key}: File (${value.name}, ${value.type}, ${value.size} bytes)`
            );
          } else {
            console.log(`${key}: ${value}`);
          }
        }
        const dataToPersist = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          willaya: data.willaya
        }
        localStorage.setItem("formData", JSON.stringify(dataToPersist));
        const response = await axios.post(
          `${backendLinkLottery}addLotteryForm`,
          formData,
          {
            withCredentials: true, // Include cookies for CSRF protection
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (response.status === 422) {
          alert(
            "Un échec est survenu ! Veuillez réessayer d'envoyer votre réclamation. Merci !"
          );
          goBack();
          return;
        }
      } catch (error) {
        setThanksPopUpVisible(false);
        console.error("Full error:", error);
        console.error("Error response:", error.response);
        console.error("Error response data:", error.response?.data);
        console.error("Error response status:", error.response?.status);
        console.error("Error response headers:", error.response?.headers);
  
        // Log validation errors if available
        if (error.response?.data?.errors) {
          console.error("Validation errors:", error.response.data.errors);
          Object.keys(error.response.data.errors).forEach((field) => {
            console.error(`Field ${field}:`, error.response.data.errors[field]);
          });
        }
  
        if (error.response && error.response.status === 422) {
          const errorMessage =
            error.response?.data?.message ||
            "Les données envoyées sont invalides !";
          alert(errorMessage);
        } else {
          alert("Une erreur est survenue veuillez réessayer");
        }
      }
    };


  const isValidEmail = (value) => {
    // Basic email pattern to check if the email is valid
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the value matches the email pattern
    return emailPattern.test(value.trim().toLowerCase());
  };

    if (!enabledModules.lottery) {
      return <Navigate to="/" replace />;
    }

    return (
        <Box
          className={classNames(styles.mainContainer)}
          sx={{
             backgroundImage: {
                xs: tenantName === "hb" ? `url(${bg_mobile})` : "none",
                md: tenantName === "hb" ? `url(${bg_desktop})` : "none",
              },
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",

          }}
          onScroll={handleScroll}>
          <Header
          isSticky={isSticky}
          currentLang={currentLang}
          setCurrentLang={setCurrentLang}
        />
          <div className={classNames(styles.container)}>
            {
              tenantName === 'hb' && 
              <img src={concours_bg} alt="" className={styles.concoursImage} 
              loading="eager"
              fetchPriority="high"
              decoding="sync"/>
            }
            <div className={styles.formContainer}>

          
              <h2 className={styles.mainText}>{t("tombolaInstructions")}</h2>
              <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                <div className={classNames(styles.inputContainer, styles.onTopContainer)}
                ref={infoContainerRef}>
                  {lotteryFormFields.includes('name') &&

                    <input
                      type="text"
                      placeholder={t("fullNamePlaceholder")}
                      maxLength={25}
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      lang={i18n.language === "ar" ? "ar" : "fr"}
                      {...register("name", {
                        maxLength: {
                          value: 25,
                          message: "Maximum length is 25 characters",
                        },
                        onChange: (e) => {
                          const sanitizedValue = xss(e.target.value);
                          // Keep only Arabic + Latin letters + spaces
                          const alphabeticValue = sanitizedValue.replace(
                            /[^A-Za-z\u0600-\u06FF\s]/g,
                            ""
                          );
                          // Enforce max length
                          e.target.value = alphabeticValue.slice(0, 25);
                        },
                      })}
                    />
                  }
                  {lotteryFormFields.includes('phone') &&

                    <input
                      type="tel"
                      placeholder={t("phonePlaceholder")}
                      maxLength={14}
                      dir="ltr"
                      style={{ margin: 0, width: "100%"}}
                      className={i18n.language === "ar" ? styles.phoneInputWrapperAr : ""}
                      {...register("phone", {
                        onChange: (e) => {
                          // Sanitize input
                          const sanitizedValue = xss(e.target.value);
                          // Format phone number
                          const formattedValue = formatPhoneNumber(sanitizedValue);
                          // Enforce max length 
                          e.target.value = formattedValue.slice(0, 14);
                        },
                      })}     
                    />
                  }
                  {/* {lotteryFormFields.includes('email') &&
                  } */}
                  {/* <input 
                  type="email" 
                  placeholder= {t("mailPlaceholder")}
                  maxLength="64"
                  dir="ltr"
                  style={{ width: "100%", direction: "ltr" }}
                  className={(
                  i18n.language === "ar"
                    ? styles.phoneInputWrapperAr
                    : "",
                    styles.email)}
                  {...register("email",{
                    onChange :(e) =>{
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9@._+-]/g,"");
                    }}
                  )}
                  /> */}
                  {lotteryFormFields.includes('willaya')&& 
                    <Controller
                    control={control}
                    name="willaya"
                    render={({field})=>(
                      <WilayaDropDown
                      setWilaya={field.onChange}
                      value={field.value}/>
                    )}
                    />
                  }
                </div>
                {lotteryFormFields.includes('img_l')&&
                  <div className={styles.inputContainer}
                  ref={imgContainerRef}>
                    <h4 className={styles.mainText}> {t("addTicketImage")} </h4>
                    <h5 className={styles.secondaryText}>{t("verifyTicket")}</h5>
                    <Controller
                    control={control}
                    name="compressedFiles"
                    render={ ({})=> (
                      <ImageUploaderLimited
                      setValue={setValue}
                      getValues={getValues}
                      maxNumber={1}/>
                    )}
                    />
                  </div>
                }
                <div className={styles.sendContainer}>
                  <button type="submit"
                    className={styles.send}
                    name="send"
                    id="send">{t('submitConcours')}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <FailureToast
            fallback={null}
            text={missingFieldsSentence}
            showToast={showToastFields}
            setShowToast={setShowToastFields}
          />
          <ConcoursSentPopup
            isVisible={isThanksPopUpVisible}
            setIsVisible={setThanksPopUpVisible}
          />
        </Box>
    )
}